import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;
export const fetchTrendingData = async () => {

  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }
  try {
     const response = await axios.post(
      `${BASE_URL}current-affairs/list?skip=0&limit=4&date_filter=all`,
      {
        keywords: []
      },
      {
        headers: {
          'accept': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        }
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
    }
};

// export const fetchTrendingallData = async (skip) => {
//   console.log(skip);
//   const accessToken = localStorage.getItem('access_token');
//   if (!accessToken) return Promise.reject("Unauthorized");

//   try {
//     const response = await axios.get(`${BASE_URL}current-affairs/?skip=${skip}&limit=8`, {
//       headers: {
//         'accept': 'application/json',
//         Authorization: `Bearer ${accessToken}`,
//       }
//     });
//     return response.data;
//   } catch (error) {
//     return Promise.reject(error);
//   }
// };



// export const fetchFilterData = async (skip, keywords,calender) => {
//   const accessToken = localStorage.getItem('access_token');
//   if (!accessToken) return Promise.reject("Unauthorized");

//   const url = `${BASE_URL}current-affairs/search/keywords?skip=${skip}&limit=8`;
//   const payload = { keywords,calender }; // This uses the dynamic user input
//   const headers = {
//     'Accept': 'application/json',
//     'Content-Type': 'application/json',
//     'Authorization': `Bearer ${accessToken}`
//   };

//   try {
//     const response = await axios.post(url, payload, { headers });
//     return response.data;
//   } catch (error) {
//     console.error('API Error:', error);
//     return Promise.reject(error.response?.data || error.message);
//   }
// };


// export const fetchFilterData = async (skip, keywords, calender) => {
//   const accessToken = localStorage.getItem('access_token');
//   if (!accessToken) return Promise.reject("Unauthorized");

//   console.log(skip, keywords, calender);

//   const url = `${BASE_URL}current-affairs/list?skip=${skip}&limit=8&date_filter=${calender}`;
//   const payload = {
//         keywords: keywords
        
//       } // This uses the dynamic user input
//   const headers = {
//     'Accept': 'application/json',
//     'Content-Type': 'application/json',
//     'Authorization': `Bearer ${accessToken}`
//   };

//   try {
//     const response = await axios.post(url, payload, { headers });
//     return response.data;
//   } catch (error) {
//     console.error('API Error:', error);
//     return Promise.reject(error.response?.data || error.message);
//   }
  
      
  
// };

export const fetchFilterData = async (skip,filter, keywords, years, months) => {
 
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) return Promise.reject("Unauthorized");

  const url = `${BASE_URL}current-affairs/list?skip=${skip}&limit=12&date_filter=all&read_filter=${filter}`;
  const payload = {
    keywords: keywords,
    years: years,   // Use the array passed in from the component
    months: months  // Use the array passed in from the component
  };

  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`
  };

  try {
    const response = await axios.post(url, payload, { headers });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return Promise.reject(error.response?.data || error.message);
  }
};




// export const fetchFilterData = async (skip, keywords, calender) => {
//   const accessToken = localStorage.getItem('access_token');
//   if (!accessToken) return Promise.reject("Unauthorized");

//   console.log(skip, keywords, calender);

//   if(keywords.length !== 0){
//     const response = await getRelevantCurrentAffairs(keywords,calender);
//     const ids = response.result_ids;
    
//     // Skip the specified number of IDs and take the next 8
//     const skippedIds = ids.slice(skip, skip + 8);
//     if(skippedIds.length !== 0){
//       const currentAffairsResponse = await getCurrentAffairsbyIds(skippedIds);
//       console.log("currentAffairsResponse",currentAffairsResponse);
//       return {items: currentAffairsResponse.current_affairs};
//     }else{
//       return {items: []};
//     }
//   }else{
//   const url = `${BASE_URL}current-affairs/list?skip=${skip}&limit=8&date_filter=${calender}`;
//   const payload = {
//         keywords: keywords
//       } // This uses the dynamic user input
//   const headers = {
//     'Accept': 'application/json',
//     'Content-Type': 'application/json',
//     'Authorization': `Bearer ${accessToken}`
//   };

//   try {
//     const response = await axios.post(url, payload, { headers });
//     return response.data;
//   } catch (error) {
//     console.error('API Error:', error);
//     return Promise.reject(error.response?.data || error.message);
//   }
//   }
      
  
// };

const getCurrentAffairsbyIds = async (ids) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) return Promise.reject("Unauthorized");
  const url = `${BASE_URL}current-affairs/list_current_affairs_by_ids`;
  const payload = ids;
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`
  }
  try {
    const response = await axios.post(url, payload, { headers });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return Promise.reject(error.response?.data || error.message);
  }
}
const getRelevantCurrentAffairs = async (keywords,calender) => {

  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) return Promise.reject("Unauthorized");
  const url = `${BASE_URL}current-affairs/get_relevant_current_affairs?num_of_results=20&date_filter=${calender}`;
  const payload = {
    keywords: keywords
  }
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`
  }
  try {
    const response = await axios.post(url, payload, { headers });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return Promise.reject(error.response?.data || error.message);
  }
}


export const ViewCurrentAffairById = async (id) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.post(`${BASE_URL}current-affairs/${id}/view`, {}, {
      headers: {
        'accept': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};





// ...existing code...

/**
 * Mark a current affair as read by ID.
 */
export const markCurrentAffairAsRead = async (id) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) return Promise.reject("Unauthorized");
  const url = `${BASE_URL}current-affairs/${id}/mark-read`;
  const headers = {
    'accept': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  try {
    const response = await axios.post(url, {}, { headers });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return Promise.reject(error.response?.data || error.message);
  }
};

/**
 * Mark multiple current affairs as read (by array of IDs).
 */
export const markMultipleCurrentAffairsAsRead = async (ids) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) return Promise.reject("Unauthorized");
  try {
    const results = await Promise.all(
      ids.map(id => markCurrentAffairAsRead(id))
    );
    return results;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Mark all current affairs as read (example: for a user).
 */


/**
 * Check if a current affair is marked as read.
 */
export const isCurrentAffairRead = async (id) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) return Promise.reject("Unauthorized");
  const url = `${BASE_URL}current-affairs/${id}/mark-read`;
  const headers = {
    'accept': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
  try {
    const response = await axios.get(url, { headers });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return Promise.reject(error.response?.data || error.message);
  }
};

